import React, { useEffect, useState } from "react";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
} from "../../shared/util/validators";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch } from "react-redux";

const ChangeRowModal = (props) => {
	const [isLoading, setIsLoading] = useState(true);

	const dispatch = useDispatch();

	const [formState, inputHandler, setFormData] = useForm(
		{
			totalPrice: {
				value: "",
				isValid: false,
			},
			discountPrice: {
				value: "",
				isValid: false,
			},
		},
		false
	);

	useEffect(() => {
		setFormData(
			{
				totalPrice: {
					value: props.totalPrice,
					isValid: true,
				},
				discountPrice: {
					value: props.discountPrice,
					isValid: true,
				},
			},
			true
		);
		setIsLoading(false);
	}, [setFormData]);

	const receiptRowChangeHandler = (event) => {
		event.preventDefault();
		dispatch({
			type: "update",
			payload: {
				orderId: props.orderId,
				discountPrice: Number(formState.inputs.discountPrice.value),
				totalPrice: Number(formState.inputs.totalPrice.value),
			},
		});

		props.close();
	};

	if (isLoading) {
		return (
			<div style={{ justifyContent: "center", display: "flex" }}>
				<CircularProgress color="inherit" />
			</div>
		);
	}
	return (
		<React.Fragment>
			<form onSubmit={receiptRowChangeHandler}>
				<Paper
					sx={{ flexGrow: 1, maxWidth: 1200, p: 2, m: 1 }}
					elevation={2}
				>
					<Grid container spacing={1}>
						<Grid md={6} xs={12}>
							<Input
								id="totalPrice"
								element="number_only"
								label="قیمت کل"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا قیمت کل را به درستی وارد کنید"
								initialValue={formState.inputs.totalPrice.value}
								inputValid={formState.inputs.totalPrice.isValid}
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
								needsThousandSeparator
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="discountPrice"
								element="number_only"
								label="پس از تخفیف"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا قیمت پس از تخفیف را به درستی وارد کنید."
								initialValue={
									formState.inputs.discountPrice.value
								}
								inputValid={
									formState.inputs.discountPrice.isValid
								}
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
								needsThousandSeparator
							/>
						</Grid>
						<Grid xs={12} md={6}>
							<Button
								disabled={!formState.isValid}
								type="submit"
								fullWidth
								color="secondary"
								variant="contained"
							>
								<EditIcon />
							</Button>
						</Grid>
						<Grid xs={12} md={6}>
							<Button
								fullWidth
								color="primary"
								variant="contained"
								onClick={props.close}
							>
								<ArrowBackIcon />
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</form>
		</React.Fragment>
	);
};

export default ChangeRowModal;
